import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './TableCellTags.css';
import Tag from '../atoms/Tag';
import CellLoader from './CellLoader';

const TableCellTags = ({
    value: tags = [],
    defaultTag = '',
    defaultColor = '',
    className = '',
    tagClassName,
    color = null,
    isLoading = false,
    loaderClass,
}) => {
    const renderTag = (tag, tagColor) => {
        return <Tag key={tag} value={tag} color={tagColor} className={tagClassName} />;
    };

    return (
        <td key={tags.join('_')} className={classNames(className, css.tagsContainer, { [css.loading]: isLoading })}>
            {isLoading ? (
                <CellLoader loaderClass={loaderClass} />
            ) : tags.length ? (
                tags.map(tag => renderTag(tag, color))
            ) : defaultTag ? (
                renderTag(defaultTag, defaultColor || color)
            ) : null}
        </td>
    );
};

TableCellTags.propTypes = {
    value: PropTypes.arrayOf(PropTypes.string),
    defaultTag: PropTypes.string,
    defaultColor: PropTypes.string,
    className: PropTypes.string,
    tagClassName: PropTypes.string,
    color: PropTypes.string,
    isLoading: PropTypes.bool,
    loaderClass: PropTypes.string,
};

export default TableCellTags;
